module.exports = __webpack_public_path__ + "img/Vorbasse-marked-t-shirt.7b8dc6ea.png";